import type { TimetableImportFile } from '../ImportTimetableModal';

export type ImportFileState =
  | { status: 'empty' }
  | { status: 'loading' }
  | { status: 'success'; file: TimetableImportFile }
  | { status: 'error' };

export type ImportFileAction =
  | { type: 'load' }
  | { type: 'success'; file: TimetableImportFile }
  | { type: 'clear' }
  | { type: 'error' };

export const INITIAL_FILE_STATE: ImportFileState = { status: 'empty' };

export function importFileReducer(
  state: ImportFileState,
  action: ImportFileAction,
): ImportFileState {
  switch (action.type) {
    case 'load':
      return { status: 'loading' };
    case 'success':
      return { status: 'success', file: action.file };
    case 'clear':
      return INITIAL_FILE_STATE;
    case 'error':
      return { status: 'error' };
    default:
      return state;
  }
}
